import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../../core/et3-ui/ET3Margin";
import CreateOneOTwoButton from "./CreateOneOTwoButton";
import CreateOneOTwoField from "./CreateOneOTwoField";
import getCorePersonalStore from "../../../../../../../stores/core/core-personal-store";
import getKhattabatSharedMessagingStore from "../../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import getKhattabat101CGeneralStore from "../../../../../../../stores/khattabat-stores/101c-stores/101c-general-store";

const CreateOneOTwoConversation = withLiteObserverAndTheme<{
  conversationID: string;
  userID: number;
}>((props) => {
  const { theme, conversationID, userID } = props;
  const { colors } = theme;
  const isKhattabaAiAdmin = getCorePersonalStore().isKhattabaAiAdmin.get();
  const isPaidConversation =
    getKhattabat101CGeneralStore().conversationsClientType.get() === "PAID";
  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();

  const isOneOOneCConversation = conversationType === "101C";
  const shouldShow =
    !isKhattabaAiAdmin && isPaidConversation && isOneOOneCConversation;
  return shouldShow ? (
    <ET3Div
      width={180}
      height={93}
      alignItems={"center"}
      fDirection={"column"}
      style={{ backgroundColor: colors.all.white }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <CreateOneOTwoField userID={userID} />
      <Et3Margin top={5} bottom={5} left={0} right={0} />
      <CreateOneOTwoButton userID={userID} />
    </ET3Div>
  ) : null;
});

export default CreateOneOTwoConversation;
